import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-grid-container',
    templateUrl: './grid-container.component.html',
    styleUrls: [
        './grid-container.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridContainerComponent
{
}
